import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './application/index';
// core styles are required for all packages
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
// import '@mantine/form/styles.css';
// import '@mantine/modals/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
// other css files are required only if
// you are using components from the corresponding package

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
